import React from 'react'
import RegistrarPonto from '../RegistrarPonto'

export default function RegistrarAtividadesRetroativas() {
  return <RegistrarPonto retroativo />
}
